export default __webpack_public_path__ + "static/media/06fa00fa115d26ac37e7e24646c3a57d.svg";